/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-05-11 15:30:26
 * @LastEditTime : 2023-06-09 16:01:48
 * @LastEditors  : yangxr
 * @Description  : 外协协外结算价
 * @FilePath     : \icps_fb\src\api\wise\Wise_contactsbusiness\contactPriceList.js
 */
import request from "@/utils/request";
/*查询*/
export const queryPage = "/icps/system/sign/settlement/cooperation/cycleManage/queryOuterListByCompany";
export const queryPageByMonth = "/icps/system/sign/settlement/cooperation/cycleManage/queryPage";
export const queryPageByMonthRecord = "/icps/system/sign/settlement/cooperation/queryPage";
//获取调价记录弹窗
export function queryHisttoryList(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/getHistoryPriceManage",
    method: "get",
    params,
  });
}
//获取信息价记录弹窗
export function queryHisttoryPeriodList(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/getHistoryInformationPerid",
    method: "get",
    params,
  });
}
//获取最近周期记录
export function queryRecentlyResord(data) {
    return request({
      url: "/icps/system/sign/settlement/cooperation/cycleManage/queryRecentlyResord",
      method: "post",
      data,
    });
  }
//生成最近周期记录
export function saveCycleManage(data) {
    return request({
      url: "/icps/system/sign/settlement/cooperation/cycleManage/saveCycleManage",
      method: "post",
      data,
    });
  }
//删除最近周期记录
export function deleteCycleManage(params) {
    return request({
      url: "/icps/system/sign/settlement/cooperation/cycleManage/deleteCycleManage",
      method: "get",
      params,
    });
  }

// 获取销售员
export function querySales(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/cycleManage/querySales",
    method: "get",
    params,
  });
}
// 月报单价确认-生成列表-更新
export function updatePriceManage(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/updatePriceManage",
    method: "get",
    params,
  });
}
//获取未维护的价格详情
export function queryPriceDetail(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/settlementPrice/queryPriceDetail",
    method: "get",
    params,
  });
}
//保存未维护价格
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/settlementPrice/saveOrUpdate",
    method: "post",
    data,
  });
}
//获取信息价期数
export function queryPeridList(data) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/queryPeridList",
    method: "post",
    data,
  });
}
//更新信息价期数
export function updateInformationPerid(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/updateInformationPerid",
    method: "get",
    params,
  });
}
//获取价格详情
export function queryPriceDetail2(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/settlementPrice/queryPriceDetail",
    method: "get",
    params,
  });
}
//更新期数
export function updatePriceDetail(params) {
  return request({
    url: "/icps/system/sign/settlement/cooperation/settlementPrice/updatePriceDetail",
    method: "get",
    params,
  });
}
/**根据工程id获取税率特殊条款*/
export function getEngPriceAdjust(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/getEngPriceAdjust',
    method: 'get',
    params: data
  })
}
/**根据合同id获取合同价格*/
export function selectOtherInformation(data) {
  return request({
    url: '/icps/system/sign/settlement/cooperation/settlementPrice/selectOtherInformation',
    method: 'post',
    data
  })
}
/**判断之前是否已有信息价*/
export function queryWaitUpdateInformationPrice(data) {
  return request({
    url: '/icps/system/sign/settlement/cooperation/settlementPrice/checkInformation',
    method: 'post',
    data
  })
}